package com.artvending.warden

class CommonColor(
	val r: Int,
	val g: Int,
	val b: Int,
	val a: Float = 1f
)